module.exports = __webpack_public_path__ + "static/img/4.afab649.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/eng/4.png
// module id = rRQf
// module chunks = 0